import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BaseComponent } from '../../shared/base.component';
import { AddCustomerState } from '../../shared/state-interface';
import { CountriesComponent } from '../../ui-components/countries/countries.component';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { CustomerComponent } from '../shared/customer.component';
import { Customer } from '../shared/customer.model';
import { CustomerService } from '../shared/customer.service';

@Component({
    selector: 'app-add-customer',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        SiteHeaderComponent,
        CustomerComponent
    ],
    templateUrl: './add-customer.component.html',
    styleUrl: './add-customer.component.css'
})
export class AddCustomerComponent extends BaseComponent implements AfterViewInit {

    @ViewChild(CustomerComponent) customerComponent!:CustomerComponent;

    private customerService: CustomerService = inject(CustomerService);
    
    private static _addingCustomer = "Adding Customer";
    private static _addingCustomerError = `${AddCustomerComponent._addingCustomer} error:`;

    public ngAfterViewInit() {
        const state: AddCustomerState | undefined = this.stateManager.addCustomerState;

        if (state !== undefined) {
            this.customerComponent.restoreState(state.customerComponentState);
            super.restoreState(state.baseComponentState);
        } else {
            this.customerComponent.init(CountriesComponent.defaultCountry);
        }
    }

    public ngOnDestroy() {
        const state: AddCustomerState = {} as AddCustomerState;
        state.customerComponentState = this.customerComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.addCustomerState = state;
    }

    protected cancel() {
        this.router.navigate(["/view-customers"], { state: { restore: true } });
    }

    protected async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const customer: Customer = this.customerComponent.createModelFromForm(new Customer());

            const observable = await this.customerService.addCustomer(await getIdToken(currentUser), customer);
            this.message = "";
            super.showSnackBar(`${AddCustomerComponent._addingCustomer}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["add-customer"] == "success") {
                        this.stateManager.clearCustomerNames();
                        const queryParam = `Customer '${customer.first_name} ${customer.last_name}' added.`;
                        this.router.navigate(["/view-customers"], { queryParams: {"overrideSnackBar": queryParam}, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${AddCustomerComponent._addingCustomerError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${AddCustomerComponent._addingCustomerError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}
